var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipsis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00684 10.6309C6.00684 11.3212 5.44719 11.8809 4.75684 11.8809C4.06648 11.8809 3.50684 11.3212 3.50684 10.6309C3.50684 9.9405 4.06648 9.38086 4.75684 9.38086C5.44719 9.38086 6.00684 9.9405 6.00684 10.6309ZM11.0068 10.6309C11.0068 11.3212 10.4472 11.8809 9.75684 11.8809C9.06648 11.8809 8.50684 11.3212 8.50684 10.6309C8.50684 9.9405 9.06648 9.38086 9.75684 9.38086C10.4472 9.38086 11.0068 9.9405 11.0068 10.6309ZM14.7568 11.8809C15.4472 11.8809 16.0068 11.3212 16.0068 10.6309C16.0068 9.9405 15.4472 9.38086 14.7568 9.38086C14.0665 9.38086 13.5068 9.9405 13.5068 10.6309C13.5068 11.3212 14.0665 11.8809 14.7568 11.8809Z",
    fill: "#616161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.94a857416ebe649384e047ab1ac5439a.svg";
export { ForwardRef as ReactComponent };